module.exports = __webpack_public_path__ + "static/media/work-sessions.8c51cdb4.png";